import { Injectable } from '@angular/core';
import {
  Activity,
  Addon,
  AffiliateAction,
  AffiliateType,
  ApplicantType,
  AppSettings,
  Bank,
  City,
  CityTree,
  Classification,
  ClassificationTree,
  ClassificationType,
  Intention,
  Interest,
  License,
  LinkType,
  OfferDemandIntention,
  Package,
  PaymentMethod,
  PropertyType,
  Province,
  PublicPropertyTypeClassification,
  Tag,
  Theme,
} from '@core/utils/models/utility.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponseAlt, HttpResponseList } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class UtilityService extends HttpHandler {
  getBanks(): Observable<HttpResponseList<Bank>> {
    const url: string = environment.apiUrls.utility.banks;
    return this.get<HttpResponseList<Bank>>(url);
  }

  getPropertyTypes(): Observable<HttpResponseList<PropertyType>> {
    const url: string = environment.apiUrls.utility.propertyTypes;
    return this.get<HttpResponseList<PropertyType>>(url);
  }

  getCities(): Observable<HttpResponseList<City>> {
    const url: string = environment.apiUrls.utility.cities;
    return this.get<HttpResponseList<City>>(url);
  }

  getCitiesTree(): Observable<HttpResponseList<CityTree>> {
    const url: string = environment.apiUrls.utility.citiesTree;
    return this.get<HttpResponseList<CityTree>>(url);
  }

  getProvinces(): Observable<HttpResponseList<Province>> {
    const url: string = environment.apiUrls.utility.provinces;
    return this.get<HttpResponseList<Province>>(url);
  }

  getIntentions(): Observable<HttpResponseList<Intention>> {
    const url: string = environment.apiUrls.utility.intentions;
    return this.get<HttpResponseList<Intention>>(url);
  }

  getInterests(): Observable<HttpResponseList<Interest>> {
    const url: string = environment.apiUrls.utility.interests;
    return this.get<HttpResponseList<Interest>>(url);
  }

  getLinkTypes(): Observable<HttpResponseList<LinkType>> {
    const url: string = environment.apiUrls.utility.linkTypes;
    return this.get<HttpResponseList<LinkType>>(url);
  }

  getSocialMediaLinks(): Observable<HttpResponseList<LinkType>> {
    const url: string = environment.apiUrls.utility.socialMediaLinks;
    return this.get<HttpResponseList<LinkType>>(url);
  }

  getThemes(): Observable<HttpResponseList<Theme>> {
    const url: string = environment.apiUrls.utility.themes;
    return this.get<HttpResponseList<Theme>>(url);
  }

  getClassifications(): Observable<HttpResponseList<Classification>> {
    const url: string = environment.apiUrls.utility.classifications;
    return this.get<HttpResponseList<Classification>>(url);
  }

  getClassificationTree(): Observable<HttpResponseList<ClassificationTree>> {
    const url: string = environment.apiUrls.utility.classificationTree;
    return this.get<HttpResponseList<ClassificationTree>>(url);
  }

  getClassificationTypes(): Observable<HttpResponseList<ClassificationType>> {
    const url: string = environment.apiUrls.utility.classificationTypes;
    return this.get<HttpResponseList<ClassificationType>>(url);
  }

  getActivities(): Observable<HttpResponseList<Activity>> {
    const url: string = environment.apiUrls.utility.activities;
    return this.get<HttpResponseList<Activity>>(url);
  }

  getLicenses(): Observable<HttpResponseList<License>> {
    const url: string = environment.apiUrls.utility.licenses;
    return this.get<HttpResponseList<License>>(url);
  }

  getAffiliateTypes(): Observable<HttpResponseList<AffiliateType>> {
    const url: string = environment.apiUrls.utility.affiliateTypes;
    return this.get<HttpResponseList<AffiliateType>>(url);
  }

  getAffiliateActions(): Observable<HttpResponseList<AffiliateAction>> {
    const url: string = environment.apiUrls.utility.affiliateActions;
    return this.get<HttpResponseList<AffiliateAction>>(url);
  }

  getAddons(): Observable<HttpResponseList<Addon>> {
    const url: string = environment.apiUrls.utility.addons;
    return this.get<HttpResponseList<Addon>>(url);
  }

  getAppSettings(): Observable<HttpResponseAlt<AppSettings>> {
    const url: string = environment.apiUrls.utility.settings;
    return this.get<HttpResponseAlt<AppSettings>>(url);
  }

  getPublicPropertyTypeClassifications(): Observable<HttpResponseList<PublicPropertyTypeClassification>> {
    const url: string = environment.apiUrls.utility.publicPropertyTypeClassifications;
    return this.post<HttpResponseList<PublicPropertyTypeClassification>>(url);
  }

  getPublicIntentions(): Observable<HttpResponseList<OfferDemandIntention>> {
    const url: string = environment.apiUrls.utility.publicIntentions;
    return this.get<HttpResponseList<OfferDemandIntention>>(url);
  }

  getTags(): Observable<HttpResponseList<Tag>> {
    const url: string = environment.apiUrls.utility.tags;
    return this.get<HttpResponseList<Tag>>(url);
  }

  getApplicantTypes(): Observable<HttpResponseList<ApplicantType>> {
    const url: string = environment.apiUrls.utility.applicantTypes;
    return this.get<HttpResponseList<ApplicantType>>(url);
  }

  getPaymentMethods(): Observable<HttpResponseList<PaymentMethod>> {
    const url: string = environment.apiUrls.utility.paymentMethods;
    return this.get<HttpResponseList<PaymentMethod>>(url);
  }

  getPackages(): Observable<HttpResponseList<Package>> {
    const url: string = environment.apiUrls.utility.packages;
    return this.get<HttpResponseList<Package>>(url);
  }
}
